// extracted by mini-css-extract-plugin
module.exports = {"ratingContainer":"kS","hidden":"kT"};